/**
 * Utilidades de identidad y formato compartidas por la UI.
 *
 * · avatarTint(nombre): color DETERMINISTA por persona. Sin foto, cada quien
 *   conserva el mismo color siempre (escaneable en listas y calendario) y no
 *   hay "arcoíris aleatorio" cada vez que se recarga la pantalla.
 * · iniciales(nombre): máximo 2 letras, tolera nombres vacíos o de una palabra.
 */

const TINTS = [
  ['187 92% 42%', '174 80% 32%'], // cian → teal (marca)
  ['199 89% 45%', '217 85% 55%'], // cielo → azul
  ['165 75% 38%', '142 66% 36%'], // esmeralda
  ['26 88% 55%', '14 80% 50%'],   // naranja
  ['272 58% 55%', '258 60% 50%'], // violeta
  ['340 72% 52%', '322 62% 46%'], // rosa
  ['42 88% 50%', '30 88% 44%'],   // ámbar
  ['210 55% 50%', '232 48% 46%'], // azul acero
];

const hash = (str = '') => {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
};

export const avatarTint = (name = '') => {
  const [from, to] = TINTS[hash(name || '?') % TINTS.length];
  return { backgroundImage: `linear-gradient(135deg, hsl(${from}), hsl(${to}))` };
};

export const iniciales = (name = '', fallback = '?') => {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return fallback;
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

/** "Buenos días" / "Buenas tardes" / "Buenas noches" según la hora local. */
export const saludo = (date = new Date()) => {
  const h = date.getHours();
  if (h < 12) return 'Buenos días';
  if (h < 19) return 'Buenas tardes';
  return 'Buenas noches';
};

/** "sábado, 12 de septiembre" (es-MX), sin depender de date-fns aquí. */
export const fechaLarga = (date = new Date()) => {
  try {
    return date.toLocaleDateString('es-MX', {
      weekday: 'long', day: 'numeric', month: 'long',
    });
  } catch {
    return date.toDateString();
  }
};

/** Primer nombre (para saludos cortos: "Julio" en vez de "Julio Dominguez"). */
export const primerNombre = (nombre = '') => String(nombre).trim().split(/\s+/)[0] || '';

/** "08:30" → 510 (minutos). Tolerante a valores inválidos. */
export const aMinutos = (hhmm = '') => {
  const [h, m] = String(hhmm).split(':').map(Number);
  return (Number.isFinite(h) ? h : 0) * 60 + (Number.isFinite(m) ? m : 0);
};

/** 510 → "08:30" */
export const aHora = (minutos) => {
  const m = Math.max(0, Math.round(minutos));
  return `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
};

export const dinero = (n, moneda = 'MXN') => {
  const v = Number(n) || 0;
  try {
    return v.toLocaleString('es-MX', { style: 'currency', currency: moneda, maximumFractionDigits: 0 });
  } catch {
    return `$${v.toLocaleString('es-MX')}`;
  }
};
